import React from 'react';
import { IoArrowForward } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const AboutStats = () => {
  const navigate = useNavigate();
  
  const stats = [
    {
      number: '30+',
      label: 'Projects delivered'
    },
    {
      number: '50M+',
      label: 'Client revenue'
    },
    {
      number: '98%',
      label: 'Client retention'
    }
  ];

  return (
    <section className="py-4 md:py-16 px-4 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        {/* Left Side - Button */}
        <div className="flex justify-center max-md:hidden lg:justify-start">
          <button 
            onClick={() => navigate('/book-consultation')}
            className="text-white px-8 py-2 rounded-full flex items-center gap-3 font-semibold text-lg hover:opacity-90 transition-opacity"
            style={{ backgroundColor: 'var(--primary-blue)' }}
          >
            Send us
            <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
              <IoArrowForward className="text-black text-sm" />
            </div>
          </button>
        </div>

        {/* Right Side - Content */}
        <div>
          <h2 className="text-2xl lg:text-4xl font-bold text-gray-900 mb-2 md:mb-6 leading-tight">
            We create thoughtful digital and visual experiences across web, mobile, branding, and photography.
          </h2>
          <p className="text-black font-light mb-12 text-base">
            Driven by detail, guided by aesthetics, and built for impact.
          </p>

          {/* Statistics */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center md:text-left">
                <div 
                  className="text-4xl lg:text-5xl font-bold mb-2"
                  style={{ color: 'var(--primary-blue)' }}
                >
                  {stat.number}
                </div>
                <div className="text-gray-600 text-sm lg:text-base">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-center md:hidden lg:justify-start">
          <button 
            onClick={() => navigate('/book-consultation')}
            className="text-white px-2 md:px-8 py-1 md:py-4 rounded-full text-sm flex items-center gap-3 font-semibold text-lg hover:opacity-90 transition-opacity"
            style={{ backgroundColor: 'var(--primary-blue)' }}
          >
            Send us
            <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
              <IoArrowForward className="text-black text-sm" />
            </div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutStats;